<template>
  <div id="app" class="app-root" :class="active">
    <div>
      <Error />
      <ConnectionStatus />
      <ConfirmationDialog />
      <router-view />
    </div>
    <vue-snotify />
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";

import ConfirmationDialog from "@/dialogs/ConfirmationDialog.vue";
import Error from "./components/Error.vue";
import ConnectionStatus from "./components/ConnectionStatus.vue";

export default {
  components: { Error, ConnectionStatus, ConfirmationDialog },
  computed: {
    ...mapGetters("users", ["isAuthed", "loaded"]),
    ...mapState("theme", ["active"])
  },
  watch: {
    isAuthed: {
      handler: function (newValue) {
        const isSignIn = this.$route.fullPath == "/signin";
        if (newValue) {
          if (isSignIn) {
            this.$router.push("/");
          }
        } else {
          if (!isSignIn) {
            this.$router.push("/signin");
          }
        }
      }
    }
  }
};
</script>

<style lang="postcss">
@import url("vue-snotify/styles/dark.css");

@import url("./styles/raster.grid.css");
@import url("./styles/themes.pcss");

@import url("./styles/display.pcss");
@import url("./styles/margins.pcss");
@import url("./styles/paddings.pcss");
@import url("./styles/sizing.pcss");
@import url("./styles/text.pcss");

@import url("./styles/app.pcss");
@import url("./styles/colors.pcss");

@import url("./styles/modals.pcss");

.card-link {
  color: var(--color-card-link);

  &.contrast {
    color: var(--color-card-link-contrast);
  }
}

.inline-pre {
  display: inline;
  padding: 0;
  margin: 0;
}

.history-inline-pre {
  white-space: pre-wrap; /* css-3 */
  white-space: -moz-pre-wrap; /* Mozilla, since 1999 */
  white-space: -pre-wrap; /* Opera 4-6 */
  white-space: -o-pre-wrap; /* Opera 7 */
  word-wrap: break-word; /* Internet Explorer 5.5+ */
  max-width: 300px;
}

.display-none {
  display: none;
}

.drop-preview {
  display: inline-block;
  background-color: rgba(150, 150, 200, 0.1) !important;
  border: 1px dashed #abc !important;
  border-radius: 8px;

  &-header-board {
    opacity: 0.3;
  }
}

.cards-drop-preview {
  background-color: rgba(150, 150, 200, 0.1);
  border: 1px dashed #abc;
  border-radius: 8px;
  margin: 5px 45px 5px 5px;
}

.card-ghost {
  transition: transform 0.18s ease;
  transform: rotateZ(-5deg);
}

.card-ghost-drop {
  transition: transform 0.18s ease-in-out;
  transform: rotateZ(0deg);
}

.v-autocomplete {
  .v-autocomplete-input-group {
    .v-autocomplete-input {
      -webkit-appearance: none;
      font-size: 1em;
      box-shadow: none;
      borde: r 1px solid #157977;
      width: 100%;
      outline: none;
      color: var(--color-input-text);
      background-color: var(--bg-input-text);
      height: 2em;
    }
    &.v-autocomplete-selected {
      .v-autocomplete-input {
        color: var(--color-input-text);
        background-color: var(--bg-input-text);
      }
    }
  }

  .v-autocomplete-list {
    width: 100%;
    text-align: left;
    border: none;
    border-top: none;
    max-height: 400px;
    overflow-y: auto;
    border-bottom: 1px solid #157977;
    .v-autocomplete-list-item {
      cursor: pointer;
      background-color: var(--bg-input-text);
      padding: 10px;
      border-bottom: 1px solid #157977;
      border-left: 1px solid #157977;
      border-right: 1px solid #157977;
      &:last-child {
        border-bottom: none;
      }
      &:hover {
        opacity: 0.8;
        /*background-color: #eee;*/
      }
      abbr {
        opacity: 0.8;
        font-size: 0.8em;
        display: block;
      }
    }
  }
}
</style>
